import { BehaviorHandler } from '../types'

/**
 * 接触したアバターの体力を 0 にするトラップの接触ハンドラ
 * （Lua: TrapScript / AttackScript の Humanoid.Health = 0）。
 *
 * rjf06（④ボスのこうげき）と rjf08（Trap ×4）で重複していた同一ハンドラを
 * 共有する。体力 0 → 死亡演出 → スポーン復帰はランタイム側が担う。
 * 状態を持たないため、ハンドラ実体は 1 つを全ミッションで共有してよい。
 */
export const killAvatarOnTouch: BehaviorHandler = ({ world }) => {
  world.setAvatarHealth(0)
}
